import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import { googleMapsConfig } from "./googleMaps";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const mapStyle = [
  {
    featureType: "poi",
    elementType: "all",
    stylers: [{ visibility: "on" }], // Landmarks visible
  },
  {
    featureType: "poi.business",
    elementType: "all",
    stylers: [{ visibility: "off" }], // Hide businesses
  },
  {
    featureType: "poi.school",
    elementType: "all",
    stylers: [{ visibility: "off" }], // Hide schools
  },
  {
    featureType: "poi.attraction",
    elementType: "all",
    stylers: [{ visibility: "on" }], // Keep attractions
  },
  {
    featureType: "road",
    elementType: "all",
    stylers: [{ visibility: "on" }], // Hide roads
  },
  {
    featureType: "transit",
    elementType: "all",
    stylers: [{ visibility: "off" }], // Hide transit stations
  },
];

function MyComponent({ doctorLocations, searchedLocation }) {
  const { isLoaded } = useJsApiLoader(googleMapsConfig);

  const [userLocation, setUserLocation] = useState(null); // State for user's current location
  const [error, setError] = useState(null); // State for any location error
  const [selectedDoctor, setSelectedDoctor] = useState(null); // State for selected doctor

  return (
    <div className="h-[50vh] md:h-[110vh] w-full relative">
      {isLoaded ? (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={
            searchedLocation ||
            userLocation || { lat: 17.4345506, lng: 78.3792185 }
          }
          zoom={searchedLocation || userLocation ? 12 : 12}
          options={{
            styles: mapStyle,
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false,
          }}
        >
          {searchedLocation && (
            <Marker
              position={searchedLocation}
              icon={{
                url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
                scaledSize: new window.google.maps.Size(32, 32),
              }}
            />
          )}
          {userLocation && (
            <Marker
              position={userLocation}
              icon={{
                url: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
                scaledSize: new window.google.maps.Size(32, 32),
              }}
            />
          )}
          {doctorLocations.map((doctor) => (
            <Marker
              key={doctor._id}
              position={{
                lat: doctor.location.coordinates[1],
                lng: doctor.location.coordinates[0],
              }}
              icon={{
                url: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
                scaledSize: new window.google.maps.Size(32, 32),
              }}
              onClick={() => setSelectedDoctor(doctor)}
            />
          ))}
          {selectedDoctor && (
            <InfoWindow
              position={{
                lat: selectedDoctor.location.coordinates[1],
                lng: selectedDoctor.location.coordinates[0],
              }}
              onCloseClick={() => setSelectedDoctor(null)}
            >
              <div>
                <h4 className="text-lg font-bold">{selectedDoctor.name}</h4>
                <p className="text-sm text-gray-500">
                  {selectedDoctor.speciality}
                </p>
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      ) : (
        <p>Loading map...</p>
      )}
      {error && (
        <div className="absolute top-2 left-1/2 transform -translate-x-1/2 bg-white p-2 rounded shadow text-sm">
          {error}
        </div>
      )}
    </div>
  );
}

export default MyComponent;
